class ProductDimension extends HTMLElement {
  constructor() {
    super();

    this.data = JSON.parse(this.querySelector("script")?.innerHTML || "{}");

    if (!this.data.values) return;

    this.innerHTML = this.data.values
      .map(({ value, unit, abbreviation, type }) => {
        if (!value) return null;

        return `${Math.round(value)}${unit in this.data.units ? this.data.units[unit] : unit}${abbreviation}`;
      })
      .filter((value) => value !== null)
      .join(" x ");
  }

  connectedCallback() {}

  disconnectedCallback() {}
}

if (!customElements.get("product-dimension")) {
  customElements.define("product-dimension", ProductDimension);
}
